<footer class="px-3 md:px-5 2xl:px-28 3xl:px-52 bg-OUT-BlueBlack text-white pt-10">
  <section
    class="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-5 border-y py-10"
  >
    <!-- Logo Section -->
    <div class="flex flex-col gap-4">
      <!-- Logo -->
      <img
        [src]="logoSrc"
        class="max-w-[200px] lg:max-w-[260px]"
        alt="only Used Tesla Logo"
      />
      <!-- Copy right Section -->
      <p class="text-sm text-[#ccc]">
        Copyright © {{ currentYear }}
        <a
          class="hover:underline transition-all duration-300"
          href="http://qureshimedia.com/"
          >Qureshi Media</a
        >
        — All rights reserved. Read our
        <a
          class="hover:underline transition-all duration-300"
          routerLink="terms-and-conditions"
          >Terms of Service.
        </a>
        Our
        <a
          class="hover:underline transition-all duration-300"
          routerLink="our-perfect-privacy-mission"
        >
          Privacy Policy</a
        >
      </p>
      <!-- Social Media Links -->
      <div class="flex items-center gap-4">
        <a
          class="bg-white hover:bg-white/80 text-black rounded-full p-0.5"
          href="https://web.facebook.com/onlyusedtesla?_rdc=1&_rdr#"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            class="size-8"
          >
            <path
              fill="currentColor"
              d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95"
            />
          </svg>
        </a>
        <a
          class="bg-white hover:bg-white/80 text-black rounded-full p-1"
          href="https://x.com/onlyusedtesla"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            class="size-7"
          >
            <path
              fill="currentColor"
              d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"
            />
          </svg>
        </a>
        <a
          class="bg-white hover:bg-white/80 text-black rounded-full p-1"
          href="https://www.instagram.com/onlyusedtesla"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <g
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              color="currentColor"
            >
              <path
                d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391S2.5 16.479 2.5 12"
              />
              <path
                d="M16.5 12a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0m1.008-5.5h-.01"
              />
            </g>
          </svg>
        </a>
        <a
          class="bg-white hover:bg-white/80 text-black rounded-full p-0.5"
          href="https://www.reddit.com/r/onlyusedtesla"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="size-8"
          >
            <path
              fill="currentColor"
              d="M10.75 13.04c0-.57-.47-1.04-1.04-1.04s-1.04.47-1.04 1.04a1.04 1.04 0 1 0 2.08 0m3.34 2.37c-.45.45-1.41.61-2.09.61s-1.64-.16-2.09-.61a.26.26 0 0 0-.38 0a.26.26 0 0 0 0 .38c.71.71 2.07.77 2.47.77s1.76-.06 2.47-.77a.26.26 0 0 0 0-.38c-.1-.1-.27-.1-.38 0m.2-3.41c-.57 0-1.04.47-1.04 1.04s.47 1.04 1.04 1.04s1.04-.47 1.04-1.04S14.87 12 14.29 12"
            />
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m5.8 11.33c.02.14.03.29.03.44c0 2.24-2.61 4.06-5.83 4.06s-5.83-1.82-5.83-4.06c0-.15.01-.3.03-.44c-.51-.23-.86-.74-.86-1.33a1.455 1.455 0 0 1 2.47-1.05c1.01-.73 2.41-1.19 3.96-1.24l.74-3.49c.01-.07.05-.13.11-.16c.06-.04.13-.05.2-.04l2.42.52a1.04 1.04 0 1 1 .93 1.5c-.56 0-1.01-.44-1.04-.99l-2.17-.46l-.66 3.12c1.53.05 2.9.52 3.9 1.24a1.455 1.455 0 1 1 1.6 2.38"
            />
          </svg>
        </a>
        <a
          class="bg-white hover:bg-white/80 text-black rounded-full p-0.5"
          href="https://www.youtube.com/@onlyusedtesla"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="size-8"
          >
            <path
              fill="currentColor"
              d="m10 15l5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73"
            />
          </svg>
        </a>
      </div>
    </div>
    <!-- Models Section -->
    <div class="flex flex-col gap-2">
      <h4 class="font-semibold text-OUT-Light-Blue">MODELS</h4>
      <ul *ngFor="let model of models" class="flex flex-col gap-2">
        <li>
          <a
            class="text-[#ccc] hover:text-white transition-colors duration-colors"
            [routerLink]="model.link"
          >
            {{ model.name }}
          </a>
        </li>
      </ul>
    </div>
    <!-- Listing Type Section -->
    <div class="flex flex-col gap-7 lg:gap-0 justify-between">
      <div class="flex flex-col gap-2">
        <h4 class="font-semibold text-OUT-Light-Blue">LISTING TYPE</h4>
        <ul *ngFor="let type of listingType" class="flex flex-col gap-1">
          <li>
            <a
              class="text-[#ccc] hover:text-white transition-colors duration-colors"
              [routerLink]="type.link"
              >{{ type.name }}</a
            >
          </li>
        </ul>
      </div>
      <div class="flex flex-col gap-2">
        <h4 class="font-semibold text-OUT-Light-Blue">LOCATION</h4>
        <ul>
          <li>
            <a
              class="text-[#ccc] hover:text-white transition-colors duration-colors"
              routerLink="/locations"
              >All Locations</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Support Section -->
    <div class="flex flex-col gap-2">
      <h4 class="font-semibold text-OUT-Light-Blue">SUPPORT</h4>
      <ul *ngFor="let support of supports" class="flex flex-col gap-1">
        <li>
          <a
            class="text-[#ccc] hover:text-white transition-colors duration-colors"
            [ngClass]="
              support.unique
                ? 'font-medium text-[#ccc] hover:text-white transition-colors duration-colors'
                : ''
            "
            [routerLink]="support.link"
            >{{ support.name }}</a
          >
          <!-- <a
            *ngIf="support.external"
            class="text-[#ccc] hover:text-white transition-colors duration-colors"
            [href]="support.link"
            >{{ support.name }}</a
          > -->
        </li>
      </ul>
    </div>
  </section>
  <div
    class="container mx-auto text-xs text-[#ccc] py-5 text-center flex justify-center"
  >
    <p class="w-full lg:w-[70%]">
      Only Used Tesla (OUT) is an independent organization and is not affiliated
      with Tesla Motors, Inc. or its subsidiaries. Tesla, Tesla Motors, Tesla
      Roadster, Model S, Model X, and the “Tesla”, “T” and “Tesla and T in
      Crest” designs are trademarks or registered trademarks of Tesla Motors,
      Inc. in the United States and other countries.
    </p>
  </div>
</footer>
